<div mat-dialog-title>
  <div class="d-flex justify-content-between">
    <p>Create Review</p>
    <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>



<div mat-dialog-content class="m-0">

  <!-- <div class="block-header" style="padding-top: 5px;">
    <div class="row m-0">
      <div class='col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12'>
        <mat-button-toggle-group aria-label="Font Style" class="p-0" style="width: 100%;"
          (change)="changeButtonToggle($event)" [value]="selectedOption">
          <mat-button-toggle value="general">General Details</mat-button-toggle>
          <!-- <mat-button-toggle value="peersubmit" (click)="generalCreation()" [disabled]="!isValidated">Project
            Details</mat-button-toggle> 
        </mat-button-toggle-group>
      </div>
    </div>
  </div> -->

  <!-- <div [hidden]="isValidated"> -->

  <div class="eip-mxy-5">
    <mat-accordion>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header [expandedHeight]="'43px'" [collapsedHeight]="'43px'">
          <mat-panel-title>
            <div class="d-flex ">
              <div class="d-flex eip-mr-20 flex-grow-1 align-items-center">
                <p class="ff-3">{{peerProjectdetails[0].project_code}} - {{peerProjectdetails[0].project_description}}
                </p>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="eip-mt-20 eip-mb-10">
          <form [formGroup]="reviewForm" autocomplete="off">
            <div class="borderBoxStyle" *ngFor="let data of ecdmem">
              <div class="row" style="background-color: #fff;">
                <div class="col-xl-4">
                  <div class="fontbold">ECD For Project</div>
                  <div>{{ data.stringAggList }}</div>
                </div>
                <div class="col-xl-4" *ngFor="let data of mecdmem">
                  <div class="fontbold">MEIC For Project</div>
                  <div>{{ data.stringAggList }}</div>
                </div>
                <div class="col-xl-4" *ngFor="let data of decdmem">
                  <div class="fontbold">DEIC For Project</div>
                  <div>{{ data.stringAggList }}</div>
                </div>
              </div>
            </div>
            <br>
            <div class="row" style="justify-content: space-around;">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <EIPAutoComplete TextField="deD_Description" ValueField="deD_Id" WaterMarkText="Review Type *"
                  formControlName="reviewType" required ShowTextValueField='N' [dataSource]='reviewType'
                  [IsCascading]='true' (valueChange)='selectedreviewtype($event)'>
                </EIPAutoComplete>
                <mat-error
                  *ngIf="reviewForm.get('reviewType').touched && reviewForm.get('reviewType').hasError('required')">
                  Review Type is Required</mat-error>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <EIPAutoComplete TextField="deD_Short_Description" ValueField="deD_Id"
                  WaterMarkText="Stages Of Review *" formControlName="stagetype" required ShowTextValueField='N'
                  [dataSource]='stagesList' [IsCascading]='true' (valueChange)='selectedstagetype($event)'>
                </EIPAutoComplete>
                <mat-error
                  *ngIf="reviewForm.get('stagetype').touched && reviewForm.get('stagetype').hasError('required')">Stages
                  Of Review is Required</mat-error>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <mat-form-field floatLabel="always" appearance="none">
                  <mat-label>Video Conference</mat-label>
                  <mat-slide-toggle  color="primary" formControlName="isvideoconference">
                  </mat-slide-toggle>
                  <textarea matInput hidden></textarea> 
                </mat-form-field>
              </div>
            </div>
            <div class="row" style="justify-content: space-around;margin-top: -20px;">
              <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <EIPMultiSelectAutoComplete [dataSource]="scopeReview" setId="ddscopeReview"
                    TextField="deD_Description" ValueField="deD_Id" ShowTextValueField='N' isEmitOnSelect="Y"
                    WaterMarkText="Scope Of Review *" (valueChange)="checkedScope($event)">
                  </EIPMultiSelectAutoComplete>
                  <mat-error *ngIf="reviewForm.get('ScopeOfReview').touched && reviewForm.get('ScopeOfReview').hasError('required')">Scope Of Review is Required</mat-error>
                </div> -->
              <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <mat-form-field style="width: 100%;">
                    <mat-label>Other Scope Of Review (Specify If Any)</mat-label>
                    <input matInput formControlName="otherScope" (change)="getotherscope()">
                  </mat-form-field>
                </div> -->
            </div>
            <div class="row" style="justify-content: space-around;">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <EIPMultiSelectAutoComplete [dataSource]="serviceList" setId="ddserviceList" TextField="deD_Description"
                  ValueField="deD_Id" ShowTextValueField='N' isEmitOnSelect="Y"
                  WaterMarkText="Services To Be Included *" (valueChange)="checkedServices($event)">
                </EIPMultiSelectAutoComplete>
                <mat-error
                  *ngIf="reviewForm.get('ServiceIncluded').touched && reviewForm.get('ServiceIncluded').hasError('required')">
                  Services To Be Included is Required</mat-error>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 ">
                <mat-label>Project OverView</mat-label>
                <div class="d-flex mt-2">
                  <div class="" *ngIf="!isProjectOverViewAvailable">
                    <i class="fa fa-upload pr-2 fs-20" title="Upload Project Overview" (click)="uploadProjectOverview()"
                      style="cursor:pointer;" aria-hidden="true"></i><span class="ff-2" style="cursor:pointer;"
                      (click)="uploadProjectOverview()">Upload Project Overview</span>
                  </div>
                  <div class="justify-content-center" *ngIf="isProjectOverViewAvailable">
                    <i aria-hidden ="true"  class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="View Attachment" (click)="viewFile('0')" >
                    </i>
                  </div>
                </div>
                
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <mat-label>PR Adequacy Checklist</mat-label>
                <div class="d-flex mt-2">
                  <div class="" *ngIf="!isPRAdequacyCheckListAvailable">
                    <i class="fa fa-upload pr-2 fs-20" title="Upload Checklist" (click)="uploadPeerReviewChecklist()"
                      style="cursor:pointer;" aria-hidden="true"></i><span class="ff-2" style="cursor:pointer;"
                      (click)="uploadPeerReviewChecklist()">Upload Checklist</span>
                  </div>
                </div>
                <div class="justify-content-center" *ngIf="isPRAdequacyCheckListAvailable">
                  <i aria-hidden ="true"  class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="View Attachment" (click)="viewFile('1')" >
                  </i>
                </div>

              </div>
             

              <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <mat-form-field style="width: 100%;">
                    <mat-label>Other Service To Be Included (Specify If Any)</mat-label>
                    <input matInput formControlName="otherService" (change)="getotherservice()">
                  </mat-form-field>
                </div> -->
            </div>

            <!-- <div class="row" style="justify-content: space-around;margin-top: -20px;"> -->
            <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <EIPMultiSelectAutoComplete [dataSource]="reqDocs" setId="ddreqDocs"
                    TextField="deD_Description" ValueField="deD_Id" ShowTextValueField='N' isEmitOnSelect="Y"
                    WaterMarkText="Required Documents *" (valueChange)="checkedReqDoc($event)">
                  </EIPMultiSelectAutoComplete>
                  <mat-error *ngIf="reviewForm.get('RequiredDoc').touched && reviewForm.get('RequiredDoc').hasError('required')">Services To Be Included is Required</mat-error>
                </div> -->
            <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <EIPMultiSelectAutoComplete [dataSource]="typeOfstrc" setId="ddtypeOfstrc"
                    TextField="deD_Description" ValueField="deD_Id" ShowTextValueField='N' isEmitOnSelect="Y"
                    WaterMarkText="Type Of Structure *" (valueChange)="checkedTypOfStruc($event)">
                  </EIPMultiSelectAutoComplete>
                  <mat-error *ngIf="reviewForm.get('typeOfStructure').touched && reviewForm.get('typeOfStructure').hasError('required')">Type Of Structure is Required</mat-error>
                </div> -->
            <!-- </div> -->

            <div class="row" style="justify-content: space-around;">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <!-- <mat-form-field style="width: 100%;"> -->
                  <mat-label >Peer Review Date</mat-label>
                  <EIPDatePicker setid="txtDocDate" WaterMark="Peer Review Date" [Min]=todaydate [Value]=docdatevalue
                    (selectedDate)='getDocDate($event, "Document Date")'>
                  </EIPDatePicker>
                  <mat-error *ngIf="this.isDocDateInvalid">
                    Document Date is required
                  </mat-error>
                <!-- </mat-form-field> -->
              </div>
              <!-- <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <app-time-picker [lable]="'Time From'" (selectedTime)="fromTimeSelected($event)"></app-time-picker>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <app-time-picker [lable]="'Time To'" (selectedTime)="toTimeSelected($event)"></app-time-picker>
              </div> -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <EIPMultiSelectAutoComplete [dataSource]="sessionList" setId="ddserviceList" TextField="deD_Description"
                  ValueField="deD_Id" ShowTextValueField='N' isEmitOnSelect="Y"
                  WaterMarkText="peer review Session *" (valueChange)="selectedSession($event)">
                </EIPMultiSelectAutoComplete>
                <mat-error
                  *ngIf="reviewForm.get('time_from').touched && reviewForm.get('time_from').hasError('time_from')">
                  Review Session is Required</mat-error>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <mat-form-field style="width: 100%;">
                  <mat-label>Document Location</mat-label>
                  <input matInput formControlName="doc_location" required>
                  <mat-error
                    *ngIf="reviewForm.get('doc_location').touched && reviewForm.get('doc_location').hasError('required')">
                    Document Location is Required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <!-- <div class="row" style="justify-content: space-around;">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <mat-form-field style="width: 100%;">
                  <mat-label>Document Location</mat-label>
                  <input matInput formControlName="doc_location" required>
                  <mat-error
                    *ngIf="reviewForm.get('doc_location').touched && reviewForm.get('doc_location').hasError('required')">
                    Document Location is Required</mat-error>
                </mat-form-field>
              </div>
            </div> -->
            <br>


          </form>
        </div>

        <div mat-dialog-actions>
          <div class="row justify-content-center flex-grow-1" style="background-color: transparent;">
            <button class="btn btn-primary" id="btnSave" [disabled]="!reviewForm.valid"
              (click)="generalCreation()">Submit</button>
          </div>
        </div>

      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <!-- </div> -->
  <!-- <div [hidden]="!isValidated">

    <div class="eip-mxy-5">
      <mat-dialog-content>
        <mat-accordion>
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header [expandedHeight]="'43px'" [collapsedHeight]="'43px'">
              <mat-panel-title>
                <div class="d-flex ">
                  <div class="d-flex eip-mr-20 flex-grow-1 align-items-center">
                    <p class="ff-3">Project Details</p>
                  </div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="eip-mt-20 eip-mb-10" style="padding: 15px;">
              <form [formGroup]="projectForm">
                <div class="row">
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div class="view-info eip-mb-20">
                      <p class="view-label peer-view-lable">Project Name</p>
                      <p class="view-data">{{peerProjectdetails[0].project_description}}</p>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div class="view-info eip-mb-20">
                      <p class="view-label peer-view-lable">Project Code</p>
                      <p class="view-data">{{peerProjectdetails[0].project_code}}</p>
                    </div>
                  </div> -->
  <!-- <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div class="view-info eip-mb-20">
                      <p class="view-label peer-view-lable">Building Type</p>
                      <p class="view-data">{{peerProjectdetails[0].building_type}}</p>
                    </div>
                  </div> -->
  <!-- <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div *ngIf="buildingtypebool">
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Building Type</p>
                        <p class="view-data">{{peerProjectdetails[0].building_type}}</p>
                      </div>
                    </div>
                    <div *ngIf="!buildingtypebool">
                      <mat-form-field style="width: 100%;">
                        <mat-label>Building Type</mat-label>
                        <input matInput formControlName="buildingType" required>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Client Name</p>
                        <p class="view-data">B&F</p>
                      </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div *ngIf="prjvaluebool">
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Project Value</p>
                        <p class="view-data">{{peerProjectdetails[0].project_value_in_lakhs}}</p>
                      </div>
                    </div>
                    <div *ngIf="!prjvaluebool">
                      <mat-form-field style="width: 100%;">
                        <mat-label>Project Value</mat-label>
                        <input matInput formControlName="projectValue" required>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div *ngIf="designbool">
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Design Fees</p>
                        <p class="view-data">{{peerProjectdetails[0].design_fee_in_lakhs}}</p>
                      </div>
                    </div>
                    <div *ngIf="!designbool">
                      <mat-form-field style="width: 100%;">
                        <mat-label>Design Fees</mat-label>
                        <input matInput formControlName="designFees" required>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div class="view-info eip-mb-20">
                      <p class="view-label peer-view-lable">Project Start Date & End Date</p>
                      <p class="view-data">{{start_end_date}}</p>
                    </div>
                  </div>

                </div>
                <div class="row">
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div *ngIf="prjbriefbool">
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Project Brief</p>
                        <p class="view-data">{{peerProjectdetails[0].project_brief_description}}</p>
                      </div>
                    </div>
                    <div *ngIf="!prjbriefbool">
                      <mat-form-field style="width: 100%;">
                        <mat-label>Project Brief</mat-label>
                        <textarea matInput formControlName="projectBrief" required> </textarea>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div *ngIf='selectednaturejob'>
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Nature of Job</p>
                        <p class="view-data">{{selectednaturejob}}</p>
                      </div>
                    </div>
                    <div *ngIf='!selectednaturejob'>
                      <EIPAutoComplete TextField="deD_Description" ValueField="deD_Id" WaterMarkText="Nature of Job"
                        formControlName="natureOfjob" required ShowTextValueField='N' [dataSource]='naturejob'
                        [IsCascading]='true' (valueChange)='selectedNaturejob($event)'>
                      </EIPAutoComplete>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div *ngIf='selectedcontracttyp'>
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Type of Contract</p>
                        <p class="view-data">{{selectedcontracttyp}}</p>
                      </div>
                    </div>
                    <div *ngIf='!selectedcontracttyp'>
                      <EIPAutoComplete TextField="deD_Description" ValueField="deD_Id" WaterMarkText="Type of Contract"
                        formControlName="contractType" required ShowTextValueField='N' [dataSource]='contracttyp'
                        [IsCascading]='true' (valueChange)='selectedContractTyp($event)'>
                      </EIPAutoComplete>
                    </div>
                  </div> -->
  <!-- <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <mat-form-field style="width: 100%;">
                      <mat-label>Project Scope of Work</mat-label>
                      <input matInput formControlName="scopeOfwork" required>
                    </mat-form-field>
                  </div> -->
  <!-- <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div *ngIf="buildAreabool">
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Built-up Area</p>
                        <p class="view-data">{{peerProjectdetails[0].built_up_area}}</p>
                      </div>
                    </div>
                    <div *ngIf="!buildAreabool">
                      <mat-form-field style="width: 100%;">
                        <mat-label>Built-up Area</mat-label>
                        <input matInput formControlName="buildArea" required>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div *ngIf="siteAreabool">
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Site Area</p>
                        <p class="view-data">{{peerProjectdetails[0].site_area}}</p>
                      </div>
                    </div>
                    <div *ngIf="!siteAreabool">
                      <mat-form-field style="width: 100%;">
                        <mat-label>Site Area</mat-label>
                        <input matInput formControlName="siteArea" required>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div *ngIf="proofConsultantbool">
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Proof Consultant Name</p>
                        <p class="view-data">{{peerProjectdetails[0].proof_consultant_name}}</p>
                      </div>
                    </div>
                    <div *ngIf="!proofConsultantbool">
                      <mat-form-field style="width: 100%;">
                        <mat-label>Proof Consultant Name</mat-label>
                        <input matInput formControlName="proofConsultant" required>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div *ngIf="archConsultantbool">
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Architectural Consultant</p>
                        <p class="view-data">{{peerProjectdetails[0].architectural_consultant_name}}</p>
                      </div>
                    </div>
                    <div *ngIf="!archConsultantbool">
                      <mat-form-field style="width: 100%;">
                        <mat-label>Architectural Consultant</mat-label>
                        <input matInput formControlName="architectureConsultant" required>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div *ngIf="structConsultantbool">
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Structural Consultant</p>
                        <p class="view-data">{{peerProjectdetails[0].structural_consultant_name}}</p>
                      </div>
                    </div>
                    <div *ngIf="!structConsultantbool">
                      <mat-form-field style="width: 100%;">
                        <mat-label>Structural Consultant</mat-label>
                        <input matInput formControlName="structureConsultant" required>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <mat-form-field style="width: 100%;">
                      <mat-label>Any Consultants to be appointed by EDRC</mat-label>
                      <input matInput formControlName="consultantAppointed">
                    </mat-form-field>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div *ngIf="submissionDatebool">
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Tender Submission Date</p>
                        <p class="view-data">{{submissionDatedefault}}</p>
                      </div>
                    </div>
                    <div *ngIf="!submissionDatebool">
                      <EIPDatePicker setid="txtSubDate" WaterMark="Tender Submission Date" [Min]=todaydate [Value]=submissionDatedefault
                        (selectedDate)='getSubmissionDate($event, "Submission Date")'>
                      </EIPDatePicker>
                      <mat-error *ngIf="this.isSubDateInvalid">
                        Tender Submission Date is required
                      </mat-error>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div *ngIf="dateLOIbool">
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Date of LOI</p>
                        <p class="view-data">{{dateLOIdefault}}</p>
                      </div>
                    </div>
                    <div *ngIf="!dateLOIbool">
                      <EIPDatePicker setid="txtLoiDate" WaterMark="Date of LOI" [Min]=todaydate [Value]=dateLOIdefault
                        (selectedDate)='getDateLoi($event, "Date LOI")'>
                      </EIPDatePicker>
                      <mat-error *ngIf="this.isDateLOIinvalid">
                        Date of LOI is required
                      </mat-error>
                    </div>
                  </div> -->
  <!-- <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <mat-form-field style="width: 100%;">
                      <mat-label>Scope for Peer Review</mat-label>
                      <input matInput formControlName="scope_for_peer" required>
                    </mat-form-field>
                  </div> -->
  <!-- <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <mat-form-field floatLabel="always" appearance="none">
                      <mat-label>EDMS Availability</mat-label>
                      <mat-slide-toggle  color="primary" formControlName="edms_availability">Required
                      </mat-slide-toggle>
                      <textarea matInput hidden></textarea> 
                    </mat-form-field>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div *ngIf="divbool">
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Division</p>
                        <p class="view-data">{{peerProjectdetails[0].division_name}}</p>
                      </div>
                    </div>
                    <div *ngIf="!divbool">
                      <mat-form-field style="width: 100%;">
                        <mat-label>Division</mat-label>
                        <input matInput formControlName="divisionName">
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div *ngIf="segbool">
                      <div class="view-info eip-mb-20">
                        <p class="view-label peer-view-lable">Segment Head</p>
                        <p class="view-data">{{peerProjectdetails[0].seg_head}}</p>
                      </div>
                    </div>
                    <div *ngIf="!segbool">
                      <mat-form-field style="width: 100%;">
                        <mat-label>Segment Head</mat-label>
                        <input matInput formControlName="segHead">
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </form>
            </div>

          </mat-expansion-panel>
        </mat-accordion>
      </mat-dialog-content>
    </div>

    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <form [formGroup]="presenterForm">
          <div class="eip-mt-20" [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
            <kendo-grid #docGrid [kendoGridBinding]="selectedServicesforgrid" [sortable]="true" [resizable]="true"
              [scrollable]="true" [reorderable]="true" id="grvEDMMemberList" width="100%"
              (cancel)="cancelRowData($event)">
              <kendo-grid-column title="SL No" filterable="false" width="20">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  {{rowIndex + 1}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Discipline" field="deD_Description" width="50">
              </kendo-grid-column>
              <kendo-grid-column title="Presenter*" width="50">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  {{dataItem.deD_Description}}
                </ng-template>
                <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <mat-form-field>
                    <mat-label>Presenter</mat-label>
                    <input type="text" matInput width="50" [value]="dataItem.presenter"
                      (change)="onValueChange($event,'presenter', dataItem);" autocomplete="off">
                  </mat-form-field>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Mail ID" width="50">
                <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <mat-form-field>
                    <mat-label>Mail ID</mat-label>
                    <input type="text" matInput width="50" (change)="onValueChange($event,'mail_id', dataItem);"
                      [value]="dataItem.mail_id" autocomplete="off">
                  </mat-form-field>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Presentation From Time*" width="30">
                <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex"> -->
  <!-- <mat-form-field>
                    <mat-label></mat-label> -->
  <!-- <app-time-picker [lable]="'Presentation From Time'" (selectedTime)="fromGridTimeSelected($event,'pfrom_time', dataItem)"></app-time-picker> -->
  <!-- <input type="time" matInput width="50" (change)="onValueChange($event,'pfrom_time', dataItem);"
                      [value]="dataItem.pfrom_time" autocomplete="off"> -->
  <!-- </mat-form-field> -->
  <!-- </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Presentation To Time*" width="30">
                <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex"> -->
  <!-- <mat-form-field>
                    <mat-label></mat-label> -->
  <!-- <app-time-picker [lable]="'Presentation To Time'" (selectedTime)="fromGridTimeSelected($event,'pto_time', dataItem)"></app-time-picker> -->
  <!-- <input type="time" matInput width="50" (change)="onValueChange($event,'pto_time', dataItem);"
                      [value]="dataItem.pto_time" autocomplete="off"> -->
  <!-- </mat-form-field> -->
  <!-- </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Remarks" width="50">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  {{dataItem.remarks}}
                </ng-template>
                <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <mat-form-field>
                    <mat-label>Remarks</mat-label>
                    <input type="text" matInput width="50" [value]="dataItem.remarks"
                      (change)="onValueChange($event,'remarks', dataItem);" autocomplete="off">
                  </mat-form-field>
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </div>
        </form>
      </div>
    </div> -->

  <!-- <div class="row"> -->
  <!-- <div class="eip-mxy-5"> -->
  <!-- <mat-accordion>
      <mat-expansion-panel [expanded]="true"> -->
  <!-- <div class="eip-mt-20 eip-mb-10"> -->
  <!-- <div class="row">
          <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-xs-10">
            <div><span>Note:</span></div>
            <div>
              <p>
                An internal workshop/meeting/discussions (among all the disciplines of operating teams) has to happen
                before the peer review and all the disciplines (of operating teams)
                shall concure the presentations made by rest of all disciplines (of the operating team) before the peer
                review. ECD / Project coordinator shall establish the same before forwarding Peer Review Request Form.
                (*) Fields are mandatory
              </p>
            </div>
          </div>
        </div> -->
  <!-- </div> -->
  <!-- </mat-expansion-panel>
    </mat-accordion> -->
  <!-- </div> -->
  <!-- </div> -->

  <!-- <div class="row justify-content-center" style="background-color: transparent;">
      <div class="eip-mxy-5">
        <div mat-dialog-actions>
          <div class="row justify-content-end flex-grow-1" style="background-color: transparent;">
            <button class="btn btn-primary" id="btnSave" (click)="peerSubmit()">Submit </button>
          </div>
        </div>
      </div>
    </div> -->

  <!-- </div> -->

</div>